import MasonryGalleryContainer from "../../../../Components/Miscellaneous/Gallery/MasonryGallery/MasonryGalleryConatiner";

const MasonryGallery = () => {
  return <MasonryGalleryContainer />;
};

export default MasonryGallery;
